import React, { useEffect, useState } from "react";
import CommonTableRow from "./CommonTableRow";
import http from "../../services/http";
import ThirdLayerRow from "./ThirdLayerRow";
import { MDBSpinner } from "mdbreact";
import { TABLE_HEADERS } from "./config";
import { sortData } from "./utils";

const SecondLayerRow = ({
  row,
  tableConfig,
  choosedSiteId,
  grouping,
  setHidedRows,
  hidedRows,
  filterForm,
  dateForm,
  addToCSVData,
  index,
  onSort,
  sortConfig
}) => {
  const [innerSortConfig, setInnerSortConfig] = useState({
    key: null,
    direction: null
  });

  const handleSort = (key) => {
    let direction = 'asc';
    if (innerSortConfig.key === key && innerSortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setInnerSortConfig({ key, direction });
  };
  const [innerData, setInnerData] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleHideExanple = () => {
    setInnerData([]);
    setIsExpanded(false);
    setIsLoading(false);
  }

  // useEffect(() => {
  //   handleHideExanple();
  // }, [sortConfig]);

  const handleRowClick = async () => {
    if (!grouping.second) return;
    setIsLoading(true);
    if (isExpanded) {
      handleHideExanple();
      return;
    }

    setIsExpanded(true);
    const baseParams = {
      siteId: choosedSiteId,
      StartDate: dateForm.from,
      EndDate: dateForm.to,
      ...filterForm,
    };
    const { data } = await http.get("/reports/main3", {
      params: {
        ...baseParams,
        grouping: grouping.second,
        [grouping.first]: row.grouping,
      },
    });
    const filteredData = data.filter((item) => item.grouping);
    setInnerData(filteredData);
    addToCSVData(filteredData, row.grouping);
    setIsLoading(false);
  };

  const renderInnerData = () => {
    if (isLoading)
      return (
        <tr>
          <td colSpan={TABLE_HEADERS.length}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <MDBSpinner small className="spinner-container" />
            </div>
          </td>
        </tr>
      );
    if (!isExpanded) return null;
    if (hidedRows.includes(row.grouping)) {
      return null;
    }
    if (innerData.length === 0 && isExpanded) {
      return <div>No data</div>;
    }

    const sortedData = sortData(innerData, innerSortConfig);

    return sortedData.map((item, index) => (
      <ThirdLayerRow
        key={row.grouping}
        index={index}
        row={item}
        firstParent={row.grouping}
        tableConfig={tableConfig}
        choosedSiteId={choosedSiteId}
        grouping={grouping}
        setHidedRows={setHidedRows}
        hidedRows={hidedRows}
        dateForm={dateForm}
        filterForm={filterForm}
        addToCSVData={addToCSVData}
        onSort={handleSort}
        sortConfig={innerSortConfig}
      />
    ));
  };

  return (
    <>
      <CommonTableRow
        row={row}
        index={index}
        tableConfig={tableConfig}
        choosedSiteId={choosedSiteId}
        handleRowClick={handleRowClick}
        level={1}
        isExpanded={isExpanded}
        setHidedRows={setHidedRows}
        hidedRows={hidedRows}
        grouping={grouping}
        onSort={onSort}
        sortConfig={sortConfig}
      />
      {grouping.second && renderInnerData()}
    </>
  );
};

export default SecondLayerRow;
